// extracted by mini-css-extract-plugin
export default {"button":"favourite_button__arNSg","button--active":"favourite_button--active__7h1nP","icon":"favourite_icon__0aFgu"};